import React, { useCallback, useEffect, useState } from "react";
import {
  TextField,
  Typography,
  Button,
  Grid,
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Pagination,
  Chip,
  PaginationItem,
} from "@mui/material";
import { RiDeleteBin6Fill } from "react-icons/ri";
import { IoEyeSharp } from "react-icons/io5";
import xlsIcon from "../../../assets/images/xls.png";
import * as XLSX from "xlsx";
import SearchBar from "../Logs/SearchBar";
import {
  NoDataFoundRow,
  StyledTableCell,
  StyledTableContainer,
  StyledTableRow,
} from "../../../components/common/StyledTableComponents";
import { useDispatch, useSelector } from "react-redux";
import { GetContactUsApi } from "../../../features/Admin/Reports/AdminReports";
import CustomDatePicker from "../../../components/common/CustomDatePicker";
import dayjs from "dayjs";
import Loader from "../../../components/common/Loader/Loader";
import NormalDatePicker from "../../../components/common/NormalDatePicker";
import CustomSearchField from "../../../components/common/CustomSearchField";
import { debounce } from "lodash";
import ExportToExcelButton from "../../../components/common/ExportToExcelButton";
import { getStatusChipColor } from "../../../components/common/StatusChip/StatusChip";
import RefreshButton from "../../../components/common/RefreshButton";
import CustomPagination from "../../../components/common/CustomPagination";
import {
  applyCellStyles,
  generateColumnWidths,
} from "../../../components/common/ExcelFormatter";
import { exportToExcelAll } from "../../../components/common/ExportToExcel";
import { convertTimestampToDate } from "../../../utils/helpers";
const ContactUs = () => {
  const dispatch = useDispatch();
  const [data, setData] = useState([]);
 const today = localStorage.getItem('serverTime') ? new Date(localStorage.getItem('serverTime')) : new Date();
  const [fromDate, setFromDate] = useState(
    dayjs(today).subtract(1, "year").toDate()
  );
  const [toDate, setToDate] = useState(dayjs(today).toDate());
  const [lodaing, setLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [page, setPage] = useState(1);
  const [Count, setCount] = useState(1);
  const [excelLogo, setExcelLogo] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  function formatDate(dateString) {
    if (!dateString) {
      return "Invalid Date"; // Handle case where dateString is undefined or invalid
    }

    const date = new Date(dateString);

    // Check if date is valid
    if (isNaN(date.getTime())) {
      return "Invalid Date"; // Handle invalid date
    }

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-indexed
    const year = date.getFullYear();

    return `${month}-${day}-${year}`;
  }


  const helperFunction = () => {
    setPage(1);
    GetRejectedCandidateReport();
  };
  const GetRejectedCandidateReport = async (
    query = searchQuery,
    page = 1,
    startDate = fromDate,
    endDate = toDate,
    pageSize = rowsPerPage
  ) => {
    setLoading(true);
    let data = {
      fromDate: formatDate(startDate),
      toDate: formatDate(endDate),
      searchitem: query.trim(),
      export: false,
      pagesize: pageSize,
      pagenumber: page === 0 ? 1 : page,
    };
    try {
      const { payload } = await dispatch(GetContactUsApi(data));
      if (payload.status === 200) {
        setData(payload.data);
        setCount(payload.totalRecords);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const GetRejectedCandidateReportReset = async (from, to) => {
    setLoading(true);
    let data = {
      fromDate: formatDate(from),
      toDate: formatDate(to),
      //   pagenumber: 1,
      //   pagesize: 10,
      //   searchitem: "",
      //   export: false,
    };
    try {
      const { payload } = await dispatch(GetContactUsApi(data));
      if (payload.status === 200) {
        setData(payload.data);
        setCount(payload.totalRecords);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  //   const GetRejectedCandidateReportExport = async () => {
  //     setExcelLogo(true);
  //     let requestData = {
  //       fromDate: formatDate(fromDate),
  //       toDate: formatDate(toDate),
  //     };

  //     try {
  //       const { payload } = await dispatch(
  //         GetContactUsApi(requestData)
  //       );

  //       if (payload.status === 200) {
  //         let data = payload.data || [];

  //         if (data.length === 0) {
  //           notifyError("No data available for export");
  //           setExcelLogo(false); // Stop showing the Excel logo
  //           return; // Early return if no data is available
  //         }

  //         exportToExcel(data); // Proceed with exporting if data is available
  //       }
  //     } catch (err) {
  //       console.error(err);
  //       notifyError("Error: Unable to export data");
  //     } finally {
  //       setExcelLogo(false);
  //     }
  //   };

  //   const exportToExcel = (data) => {
  //     if (data.length === 0) {
  //       notifyError("Data not available for export");
  //       return;
  //     }

  //     try {
  //       const formattedData = data.map((row, index) => {

  //        const OfferRejectDate = row.candidate_statusinfo.find(
  //             (statusInfo) =>
  //               statusInfo.status.toLowerCase() === "rejected"
  //           );
  //           const offerRejectDate = OfferRejectDate
  //             ? formatDate2(OfferRejectDate.cdate.$date)
  //             : "";

  //         const location =
  //           row.candidate_anylocation === "any"
  //             ? "Any"
  //             : row.candidate_specifiedlocation?.join(", ") || "N/A";

  //         const experties = row.candidate_expertise
  //           ?.map((expertise) => expertise.label)
  //           .join(", ") || "N/A";

  //         return {
  //           No: row.serialnumber,
  //           "Name of Candidate": `${row.candidate_firstname || ""} ${row.candidate_lastname || ""}`,
  //           "Job Title": row.candidate_company?.[0]?.job_title || "N/A",
  //           Email: row.candidate_email || "N/A",
  //           "Contact No": row.candidate_contactno || "N/A",
  //           // "Geography Preferences": location,
  //           "Rejection Reason": row.rejectionreason || "N/A",
  //           Expertise: experties,

  //           "Uploaded By": row.recruiter_name || "N/A",
  //           "Status Modified Date": offerRejectDate,
  //         };
  //       });

  //       exportToExcelAll(formattedData, "Rejected Candidates", "Rejected Candidates.xlsx");
  //     } catch (error) {
  //       console.error(error);
  //     } finally {
  //       setExcelLogo(false);
  //     }
  //   };

 
  const handleFromDateChange = (date) => {
    setFromDate(date); // Update the from date
    // If the new from date is greater than the current to date, reset the to date
    if (toDate && date > toDate) {
      setToDate(null);
    }
  };

  const handleToDateChange = (date) => {
    setToDate(date);
  };
  const handleRowsPerPageChange = (newRowsPerPage) => {
    setPage(1);
    setRowsPerPage(newRowsPerPage);
    GetRejectedCandidateReport(
      searchQuery,
      1,
      fromDate,
      toDate,
      newRowsPerPage
    );
  };

  function formatDate2(dateString) {
    if (!dateString) {
      return "Invalid Date"; // Handle case where dateString is undefined or invalid
    }

    const date = new Date(dateString);

    // Check if date is valid
    if (isNaN(date.getTime())) {
      return "Invalid Date"; // Handle invalid date
    }

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-indexed
    const year = date.getFullYear();

    return `${month}/${day}/${year}`;
  }

  const truncateText = (text, limit = 100) => {
    if (text?.length > limit) {
      return text.substring(0, limit) + "..."; // Truncate and add ellipsis
    }
    return text;
  };
  const handlePageChange = (value) => {
    setPage(value);
    GetRejectedCandidateReport(searchQuery, value);
  };
  const debouncedSearch = useCallback(
    debounce((query, page, updatedFrom, updatedTo) => {
      GetRejectedCandidateReport(query, 1, updatedFrom, updatedTo);
    }, 1300),
    []
  );
  useEffect(() => {
    setPage(1);
    debouncedSearch(searchQuery, 1, fromDate, toDate);
  }, [searchQuery]);

  const reset = async () => {
    setSearchQuery("");
    let from = dayjs().subtract(1, "year").toDate();
    let to = dayjs().toDate();
    setFromDate(from);
    setToDate(to);
    setRowsPerPage(10);
    setTimeout(() => GetRejectedCandidateReportReset(from, to), 0);
    setPage(1);
  };

  if (lodaing) return <Loader />;

  return (
    <>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography
          variant="body1"
          sx={{
            fontSize: "16px",
            fontWeight: 700,
            lineHeight: "40px",
            textAlign: "left",
          }}
        >
          Contact Us
        </Typography>
      </Box>

      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", md: "row" }, // Row on medium screens, column on small screens
          justifyContent: "space-between",
          alignItems: "center",
          backgroundColor: "#fff",
          p: 3,
          borderRadius: "10px",
        }}
      >
        <Grid
          container
          spacing={2}
          alignItems="center"
          justifyContent="space-between"
        >
          {/* Left Section: Date Pickers and Apply Button */}
          <Grid item xs={12} md={8}>
            <Grid container spacing={2} alignItems="center">
              {/* From Date Picker */}
              <Grid item xs={12} sm={6} md={3}>
                <NormalDatePicker
                  label="From date"
                  name="from_date"
                  selected={fromDate}
                  onChange={handleFromDateChange}
                  maxDate={today} // Disable dates greater than today
                />
              </Grid>

              {/* To Date Picker */}
              <Grid item xs={12} sm={6} md={3}>
                <NormalDatePicker
                  label="To date"
                  name="to_date"
                  selected={toDate}
                  onChange={handleToDateChange}
                  maxDate={today} // Disable dates greater than today
                  minDate={fromDate} // Only allow dates greater than or equal to the from date
                />
              </Grid>

              {/* Apply and Refresh Buttons */}
              <Grid item xs={12} sm={6} md={4}>
                <Grid container spacing={2} alignItems="center">
                  {/* Apply Button */}
                  <Grid item>
                    <Button
                      variant="contained"
                      color="primary"
                      size="small"
                      sx={{ fontFamily: "Urbane-Light" }}
                      onClick={() => helperFunction()}
                    >
                      Apply
                    </Button>
                  </Grid>

                  {/* Refresh Button */}
                  <Grid item>
                    <RefreshButton onClick={reset} />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          {/* Right Section: Search Field and Export Button */}
          <Grid item xs={12} md={4}>
            <Grid
              container
              spacing={2}
              alignItems="center"
              justifyContent="flex-end"
            >
             
            </Grid>
          </Grid>
        </Grid>
      </Box>

      <Box>
        <StyledTableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow sx={{ backgroundColor: "#ECF1FF" }}>
                <StyledTableCell>No.</StyledTableCell>
                <StyledTableCell>Date</StyledTableCell>
                <StyledTableCell>Name</StyledTableCell>
                <StyledTableCell>Email</StyledTableCell>
                <StyledTableCell>Subject</StyledTableCell>
                <StyledTableCell colSpan={2}>Message</StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data && data.length > 0 ? (
                <>
                  {data.map((row, index) => {
                    return (
                      <TableRow
                        key={index}
                        sx={{
                          "&:nth-of-type(odd)": { backgroundColor: "#f5f5f5" },
                          fontSize: "12px",
                        }}
                      >
                        <StyledTableRow>{row.serialnumber}.</StyledTableRow>
                        <StyledTableRow>{convertTimestampToDate(row?.cdate?.$date)}</StyledTableRow>
                        <StyledTableRow>{row.name}</StyledTableRow>
                        <StyledTableRow>{row.email}</StyledTableRow>
                        <StyledTableRow>{row.subject}</StyledTableRow>

                        <StyledTableRow colSpan={2}>
                          {row.message}
                        </StyledTableRow>
                      </TableRow>
                    );
                  })}
                </>
              ) : (
                <>
                  <NoDataFoundRow
                    colSpan={9}
                    message="Details are not available!"
                  />
                </>
              )}
            </TableBody>
          </Table>
        </StyledTableContainer>
        {data?.length > 0 && (
        <div>
        <CustomPagination
          totalRecords={Count}
          rowsPerPageOptions={[10, 25, 50, 100]}
          initialRowsPerPage={rowsPerPage}
          setRowsPerPage1={setRowsPerPage}
          initialPage={page - 1}
          onPageChange={handlePageChange}
          onRowsPerPageChange={handleRowsPerPageChange}
        />
      </div>
        )}
      </Box>
    </>
  );
};

export default ContactUs;


